import { isNumber } from 'lodash';

export const isValidNumber = (valueNumber) =>
  isNumber(valueNumber) && !isNaN(valueNumber);

export const formatPrice = (rawPrice) => {
  if (!isValidNumber(rawPrice)) return null;
  const convertedPrice = rawPrice / 100;
  return Number(convertedPrice.toFixed(2));
};
